import VisibleComponent from '../VisibleComponent'
import './index.less'

const template = `
    <div>
        <div></div>
    </div>
`

/**
 * Text类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Text extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        this.textElem = this.element.querySelector('div')
        const {
            type,
            text,
            line,
            fontSize,
            icon,
            color,
            textClassName,
            onClick = () => {},
        } = options
        if(text){
            if(type === "rating"){
                let ratingText = text ? (text - 0).toFixed(1) : "5.0";
                this.textElem.innerText = ratingText;
            }else{
                this.textElem.innerText = text;
            }
        }
        if (type === "numberRating") {
            this.imgElem = new Image();
            this.textElem.insertBefore(this.imgElem,this.textElem.firstChild)
            if(icon){
                this.imgElem.src = icon;
            }else{
                this.imgElem.src = "https://hybird.rayjump.com/static/icon_user.png";
            }
        }
        switch (type) {
            case "title":
                this.element.classList.add("mtg-title")
                break;
            case "desc":
                this.element.classList.add("mtg-subTitle")
                this.textElem.classList.add("mtg-desc")
                break;
            case "rating":
                this.element.classList.add("mtg-subTitle")
                this.textElem.classList.add("mtg-rating")
                break;
            case "numberRating":
                this.element.classList.add("mtg-subTitle")
                this.textElem.classList.add("mtg-number-rating")
                break;
            default:
                this.element.classList.add("mtg-text")
        }
        switch (line) {
            case "1":
                this.textElem.classList.add("line-clamp1")
                break;
            case "2":
                this.textElem.classList.add("line-clamp2")
                break;
            case "3":
                this.textElem.classList.add("line-clamp3")
                break;
            default:
                if(type === "title"||type==="desc"){
                    this.textElem.classList.add("line-clamp1")
                }
        }
        if(color){
            this.textElem.style.color = color;
        }
        if(fontSize){
            this.textElem.style.fontSize = fontSize;
        }
        textClassName && this.addClass(this.element, textClassName)
        this.element.addEventListener('click', onClick, false)
    }

    setInnerText(str) {
        this.textElem.innerText = str
    }
}

export default Text